<template>
  <div class="QRcode">
    <br />
    <p style="text-align:right">{{ this.userName }}&emsp;</p>
    <!--説明・お問合せリンク-->
    <div class="link">
      <a href="https://njc.bz/helpc" target="_blank" rel="noopener noreferrer"
        >説明・お問合せ</a
      >
    </div>
    <h1 class="font-weight-bold">NJCしょーたくん</h1>
    <p>version1.8.1</p>
    <br />
    <!-- URL入力画面 -->
    <div class="wrap" v-if="this.isActive == true">
      <br />
      <input
        class="input_URL custom"
        type="url"
        v-model="url"
        placeholder="URLを入力してください"
        required
      /><br /><br />
      <input
        class="input_URL custom"
        type="text"
        v-model="memo"
        placeholder="メモ(任意)"
        required
      /><br /><br />
      <!-- 実行ボタン ~短縮URL生成~ -->
      <button class="btn btn-primary btn-lg button" v-on:click="DataPost()">
        短縮URL生成</button
      ><br /><br />
      <router-link class="btn btn-primary btn-lg button" to="/list"
        >発行済みURL一覧</router-link
      >
    </div>
    <!-- 短縮URL＆QR生成画面 -->
    <div class="wrap2" v-if="QRcode && this.isActive == false">
      <br />
      <p style="font-size:150%;">ShortURL</p>
      <!-- QR表示 -->
      <div style="text-align:center">
        (https://s.njc.jp/{{ this.outPut_Shortenurl }})
      </div>
      <vue-qrcode :value="QRcode" :options="option" tag="img"></vue-qrcode
      ><br /><br />
      <div class="copy-target">
        <p class="copyClass1">
          <span>https://njc.bz/{{ this.outPut_Shortenurl }}</span
          ><button
            id="url-button"
            class="btn btn-primary"
            v-on:click="URLCopy(1)"
          >
            URLコピー
          </button>
        </p>
        <p class="copyClass2">
          <span>https://s.njc.jp/{{ this.outPut_Shortenurl }}</span
          ><button
            id="url-button"
            class="btn btn-primary"
            v-on:click="URLCopy(2)"
          >
            URLコピー
          </button>
        </p>
        <p class="copyClass3">
          <span>https://urls.njc.co.jp/{{ this.outPut_Shortenurl }}</span
          ><button
            id="url-button"
            class="btn btn-primary"
            v-on:click="URLCopy(3)"
          >
            URLコピー
          </button>
        </p>
        <br class="urls" />
      </div>
      <!-- 実行ボタン ~入力画面に戻す~ -->
      <button
        class="btn btn-primary"
        style="width:150px; height: 50px;"
        v-on:click="active"
      >
        Homeに戻る
      </button>
    </div>
  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import axios from 'axios'
import { EMAIL } from '../constants'

const config = {
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': '1qazxsw23edcvfr45tgbnhy67ujm,ki8njc',
    'go-api-key': 'bhxvgz996'
  }
}

export default {
  // name: 'QRcode',
  components: {
    VueQrcode
  },
  data () {
    return {
      apiUrl:
        'https://3weyfv5h45.execute-api.ap-northeast-1.amazonaws.com/api/',
      isActive: true,
      url: '',
      // localStorageからEMAIL情報を受け取り、Base64から文字データへ
      base64: localStorage.getItem(EMAIL),
      userName: decodeURIComponent(escape(atob(localStorage.getItem(EMAIL)))),
      memo: '',
      QRcode: '',
      UserMessage: '',
      // QRコードの表示オプション
      option: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 1,
        scale: 2,
        width: 200,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      },
      outPut_url: undefined,
      outPut_Shortenurl: undefined
    }
  },
  methods: {
    // ShortURL(コピー機能)
    URLCopy: function (index) {
      var copy = document.querySelector('.copyClass' + index)
      var range = document.createRange()
      range.selectNodeContents(copy)
      var select = window.getSelection()
      select.removeAllRanges()
      select.addRange(range)
      if (document.execCommand('copy')) {
        alert('コピーできました')
      } else {
        alert('Ctrl+Cを押してください')
      }
    },
    // 入力時の処理(POST)
    DataPost: function () {
      // 入力内容(URL、ユーザー情報、メモ)をpostDataに入れる
      const postData = {
        url: this.url.trim(),
        userName: this.userName,
        memo: this.memo
      }
      axios
        .post(this.apiUrl, postData, config)
        // Postが成功した場合の処理
        .then(result => {
          this.Id = result.data['id']
          this.QRcode = 'https://s.njc.jp/' + result.data['id'] // ['shortenURL']
          /* eslint-disable */
          console.log(result);
          /* eslint-enable */
          // 入力成功時の処理
          if (result.data['result'] === 'success') {
            this.isActive = !this.isActive
            this.outPut_url = result.data['url']
            this.outPut_Shortenurl = result.data['id'] // ['shortenURL']
            /* eslint-disable */
            console.log(this.isActive);
            /* eslint-enable */
          } else {
            // 入力失敗時の処理
            this.UserMessage = result.data['userMessage']
            switch (this.UserMessage) {
              case 'リクエストの中の、必要なパラメータが正しくありません(ユーザー情報が違います)':
                console.log("Error1 ユーザー情報誤入力"); //eslint-disable-line
                alert('ユーザー情報が違います')
                break
              case 'リクエストの中の、必要なパラメータが正しくありません。(URLではありません)':
                console.log("Error2 URL情報誤入力"); //eslint-disable-line
                alert('URLが違います')
                break
              case 'リクエストの中の、必要なパラメータが正しくありません。(ユーザー情報が入力されていません)':
                console.log("Error3 ユーザー情報未入力"); //eslint-disable-line
                alert('ユーザー情報が入ってません')
                break
              case 'リクエストの中の、必要なパラメータが正しくありません。(URLが入力されていません)':
                console.log("Error4 URL情報未入力"); //eslint-disable-line
                alert('URLが未入力です')
                break
              case 'リクエストの中の、必要なパラメータが正しくありません。(URL、ユーザー情報が違います)':
                console.log("Error5 URL,ユーザー情報誤入力"); //eslint-disable-line
                alert('URL、ユーザー情報が違います')
                break
              case 'リクエストの中の、必要なパラメータが正しくありません。(URLとユーザー情報が入力されていません)':
                console.log("Error6 URL,ユーザー情報未入力"); //eslint-disable-line
                alert('URL、ユーザー情報が未入力です')
                break
            }
          }
        })
        // その他の処理
        .catch(error => {
          console.error(error); //eslint-disable-line
        })
    },
    // 「Homeに戻る」を押したときの切り替えと値の初期化
    active: function () {
      // 画面の切り替えを行う(false -> true)
      this.isActive = !this.isActive
      console.log(this.isActive); //eslint-disable-line
      // 値の初期化
      this.url = ''
      this.memo = ''
    }
  }
}
</script>

<style scoped>
/*説明・お問合せリンク*/
.link {
  position: absolute;
  top: 100px;
  left: 100px;
}
/*URL,MEMOの入力部分*/
.input_URL {
  resize: none;
  width: 1200px;
  height: 50px;
  text-align: left;
}
/*QR生成 履歴ボタンの設定*/
.button {
  width: 200px;
  height: 50px;
}
/*短縮URL生成画面*/
.wrap {
  position: relative;
  /* border:1px #ccc solid; */
  height: 320px;
  margin: auto;
  width: 1250px;
  box-shadow: 0px 4px 10px #ccc;
}
/*短縮URL、QR表示画面*/
.wrap2 {
  position: relative;
  height: 600px;
  margin: auto;
  width: 350px;
  box-shadow: 0px 4px 10px #ccc;
}

/*表示される短縮URL、URLコピーボタンの設定 */
.copy-target {
  text-align: right;
  font-size: 100%;
  margin-right: 30px;
}

span {
  margin-right: 10px;
}

#url-button {
  width: 75px;
  height: 30px;
  font-size: 60%;
}

.home::before {
  content: "\A";
  white-space: pre;
}

/*各ブラウザごとに表示設定*/
.custom::-webkit-input-placeholder {
  color: rgb(170, 170, 170);
  font-size: 100%;
  font-weight: normal;
  text-align: left;
}
.custom::-ms-input-placeholder {
  color: rgb(170, 170, 170);
  font-size: 100%;
  font-weight: normal;
  text-align: left;
}
.custom::-moz-placeholder {
  color: rgb(170, 170, 170);
  font-size: 100%;
  font-weight: normal;
  text-align: left;
}

@media screen and (max-width: 480px) {
  .link {
    position: absolute;
    top: 100px;
    left: 40px;
  }
  .input_URL {
    resize: none;
    width: 90%;
    height: 50px;
    text-align: left;
  }

  .button {
    resize: none;
    font-size: 125%;
    width: 55%;
    height: 15%;
  }

  .wrap {
    position: relative;
    /* border:1px #ccc solid; */
    height: 320px;
    margin: auto;
    width: 350px;
    box-shadow: 0px 4px 10px #ccc;
  }
  .wrap2 {
    /* display:-webkit-flex;
  display:-ms-flexbox;
  justify-content:center; */
    /* align-self: auto; */
    position: relative;
    /* border:2px #ccc solid; */
    height: 530px;
    margin: auto;
    width: 350px;
    box-shadow: 0px 4px 10px #ccc;
  }

  .custom::-webkit-input-placeholder {
    color: rgb(170, 170, 170);
    font-size: 100%;
    font-weight: normal;
    text-align: left;
  }
  .custom:-ms-input-placeholder {
    color: rgb(170, 170, 170);
    font-size: 100%;
    font-weight: normal;
    text-align: left;
  }
  .custom::-moz-placeholder {
    color: rgb(170, 170, 170);
    font-size: 100%;
    font-weight: normal;
    text-align: left;
  }

  .urls {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QRCodeGenerator.vue